import { LATEST_TEMPLATE_INTERACTION } from './actions'
import { LatestTemplateInteractionAction } from './interfaces'

const initialState = {
  latestTemplateInteraction: null,
}

export function reducer(state: State.PreviouslyOrdered = initialState, action: LatestTemplateInteractionAction): State.PreviouslyOrdered {
  switch (action.type) {
    case LATEST_TEMPLATE_INTERACTION:
      return {
        ...state,
        latestTemplateInteraction: action.payload.latestTemplateInteraction,
      }
    default:
      return state
  }
}
